import { render, staticRenderFns } from "./checkCode.vue?vue&type=template&id=54f4169e&scoped=true&"
import script from "./checkCode.vue?vue&type=script&lang=js&"
export * from "./checkCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4169e",
  null
  
)

export default component.exports